import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "xvhe4elt",
  dataset: "production",
});
